//Creamos la variable de enumeraciones
const enumeraciones = {};

enumeraciones.modulos = {  
  Cedulas: {
    id: 1,
    funciones: [
      { id: 10, icono: 'fas fa-file-alt'}, // creacion
      { id: 11, icono: 'fas fa-ban'}, // cancelacion
      { id: 12, icono: 'fas fa-sitemap'}, // asignacion
      { id: 14, icono: 'fas fa-pen-square'}, // Correccion con resultado
      { id: 15, icono: 'fas fa-pen-square'}, // Correccion sin resultado
      { id: 16, icono: 'fas fa-paper-plane'} // Envio
    ]
  },
  Consultas: {
    id: 2,
    funciones: [
      { id: 1, icono: 'fas fa-tasks'}, // consulta dirreccion
      { id: 2, icono: 'fas fa-tasks'}, // consulta juzgado
      { id: 3, icono: 'fas fa-book'}, // consulta publica
      { id: 4, icono: 'fas fa-calendar-alt'} // consulta salidas del dia
    ]
  },
  Administracion: {
    id: 3,
    funciones: [
      { id: 5, icono: 'fas fa-draw-polygon'}, // zonas 
      { id: 6, icono: 'fas fa-map-marked-alt'}, // fraccionamientos
      { id: 7, icono: 'fas fa-users-cog'}, // Notificadores
      { id: 17, icono: 'fas fa-building'}, // Empresas 
      { id: 18, icono: 'fas fa-file-alt'} // plantillas
    ]
  },
  Notificaciones: {
    id: 4,
    funciones: [
      { id: 8, icono: 'fas fa-truck'}, // Salidas del día  
      { id: 9, icono: 'fas fa-poll-h'} // Resultados 
    ]
  },
  Reportes: {
    id: 5,
    funciones: [
      { id: 20, icono: 'fas fa-chart-bar'}, // Reporte de cedulas enviadas a juzgado 
      { id: 21, icono: 'fas fa-chart-bar'}, // Reporte de cedulas enviadas a dirección 
      { id: 22, icono: 'fas fa-chart-bar'}, // Reporte cedulas de notificador  
      { id: 26, icono: 'fas fa-chart-bar'}  // Reporte cedulas creadas en juzgado
    ]
  }
}

//Asignamos los datos necesarios del enumeraciones
enumeraciones.catalogos = {  
  DireccionesDeNotificadores: 'direccionesNotificadores',
  TiposDeCedula: 'tiposCedula',
  Notificadores: 'notificadores',
  Zonas: 'zonas',
  Estatus: 'estatusDeCedula'  
}

enumeraciones.requierenPlantilla = {
  cedula: { llave: 1, valor: 'Cédula' },
  resultado: { llave: 2, valor: 'Resultado' },
  razon: { llave: 3, valor: 'Razon' }
}

enumeraciones.tiposEstatus = {
  creada: 1,
  enviada: 3,
  cancelada: 5,
  finalizado: 8,
  incompleta: 10
}

enumeraciones.juzgadosMixtos = {
  Pabellon: 17,
  Calvillo: 18,
  RinconDeRomos: 24,
  JesusMaria: 29
  //JesusMaria: 36
}

enumeraciones.direccionesNotificadores = {
  Civiles: 36,
  Laborales: 103,
  MixtoJesusMaria: 29
}

enumeraciones.juzgadosMixtosPuntosInicio = {
  Pabellon: [22.147445, -102.278241],
  Calvillo: [21.846032, -102.720767],
  RinconDeRomos: [22.230050, -102.322614],
  JesusMaria: [22.961052, -102.345295]
}

enumeraciones.estadosNivelDeUrgencia = {
  Rojo: 1,
  Amarillo: 2,
  Verde: 3
}

enumeraciones.fraccionamientos = {
  api: {
    URL_BASE: 'https://api.copomex.com/query/',
    metodos: {
      GET_COMPUESTO: 'search_cp_advanced/',
      GET_MUNICIPIOS: 'get_municipio_por_estado/',
      GET_CP_MUNICIPIO: 'get_cp_por_municipio/',
      GET_FRACC_CP: 'get_colonia_por_cp/'
    },
    TOKEN: 'token=f012ddf8-b114-4a6f-95f3-246d0886ab93'
  }
}

enumeraciones.tiposResultado = {
  Razonada: 1,
  Realizada: 2,
  Cancelada: 3,
  ParcialmenteRealizada: 4 // citatorios
}

enumeraciones.mapas = {
  google: {
    googleStreets: 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', // modo de visualizacion de calles
    googleHybrid: 'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', // modo de visualizacion hibrido
    googleSat: 'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', // modo de visualizacion satelite
    googleTerrain: 'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}' 
  }
}

//Exportamos los datos de enumeraciones
export default enumeraciones;



//////////////////
// WEBPACK FOOTER
// ./static/js/enumeraciones/sinoj.js
// module id = null
// module chunks = 